import React from "react";

// Lazy imports for *custom* pages only.
// Add new lines as you create more bespoke pages.
const Silage = React.lazy(() => import("./Silage"));
const ACCSystem = React.lazy(() => import("./ACCSystem"));
const cnc = React.lazy(() => import("./CNC"));
const canopener = React.lazy(() => import("./canopener"));
const psu = React.lazy(() => import("./psu"));
const SmartParking = React.lazy(() => import("./SmartParking"));
const DiNAT = React.lazy(() => import("./DiNAT"));
const Gearbox = React.lazy(() => import("./Gearbox"));

// Map project `id` -> component
export const PROJECT_PAGE_REGISTRY = {
  smartparking: SmartParking,
  silage: Silage,
  accsystem: ACCSystem,
  canopener: canopener,
  psu: psu,
  dinat: DiNAT,
  // canopener: React.lazy(() => import("./CanOpener")),
  // screwdriver: React.lazy(() => import("./Screwdriver")),
  cnc: cnc,
  gearbox: Gearbox,
  // robot: React.lazy(() => import("./Robot")),
  // breakout: React.lazy(() => import("./Breakout")),
  // reversi: React.lazy(() => import("./Reversi")),
  // petpal: React.lazy(() => import("./Petpal")),
  // onlineorder: React.lazy(() => import("./OnlineOrder")),
};
